/** Text helpers for the stored dataset topography block (GET /api/datasets/:id/topography). */
export function samplingText(t) {
  if (t.source === 'file') return t.file_name ? `terrain file ${t.file_name}` : 'terrain file';
  return t.sampling === 'interval' && t.interval_m != null ? `${t.interval_m} m interval` : 'at each electrode';
}

export function smoothingText(t) {
  return t.smoothing === 'moving_average' && t.window_m != null ? ` + ${t.window_m} m moving average` : '';
}

export function topographyDate(t) {
  return String(t.created_at || '').slice(0, 10);
}

export function topographySummary(t) {
  const els = t.electrodes || [];
  const zs = els.map((e) => e.z).filter((z) => typeof z === 'number' && Number.isFinite(z));
  const range = zs.length ? `, ${Math.min(...zs).toFixed(2)}–${Math.max(...zs).toFixed(2)} m` : '';
  const date = topographyDate(t);
  return `Topography applied: ${els.length} electrodes from ${t.source === 'file' ? 'terrain file' : 'DEM'}${range}, ${samplingText(t)}${smoothingText(t)}${date ? `, ${date}` : ''}`;
}
